import { render, staticRenderFns } from "./portsList.vue?vue&type=template&id=4db711f5"
import script from "./portsList.vue?vue&type=script&lang=js"
export * from "./portsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports